import React, { useState } from 'react';
import { AppBar, Container, Link as MuiLink, Paper, styled, Toolbar, Typography } from '@mui/material';
import { Link as RouterLink, Route, Routes, useSearchParams } from 'react-router-dom';
import { SITE_TITLE } from '../../utils';
import EmailVerification from '../EmailVerification';
import CreateAccountForm from './CreateAccountForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';

const AppContent = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(7),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(8),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const Background = styled('div')({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
});

function UnauthApp() {
  const [urlSearchParams] = useSearchParams();
  const token = urlSearchParams.get('token');
  const email = urlSearchParams.get('email');
  const [formToShow, setFormToShow] = useState<'LOGIN' | 'CREATE_ACCOUNT' | 'FORGOT_PASSWORD'>(
    token ? 'CREATE_ACCOUNT' : 'LOGIN',
  );
  return (
    <Routes>
      <Route
        path="/verify-email"
        element={
          <>
            <AppBar position="fixed">
              <Toolbar>
                <Typography variant="h5" sx={{ flexGrow: 1 }}>
                  {SITE_TITLE}
                </Typography>
              </Toolbar>
            </AppBar>
            <AppContent>
              <EmailVerification />
            </AppContent>
          </>
        }
      />
      <Route
        path="reset-password"
        element={
          <>
            <AppBar position="fixed">
              <Toolbar>
                <Typography variant="h5" sx={{ flexGrow: 1 }}>
                  {SITE_TITLE}
                </Typography>
              </Toolbar>
            </AppBar>
            <AppContent>
              <ResetPasswordForm token={token} />
            </AppContent>
          </>
        }
      />
      <Route
        path="*"
        element={
          <Background>
            <Container
              maxWidth="sm"
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Paper sx={{ p: 2 }}>
                {formToShow === 'LOGIN' && <LoginForm onSwitchForm={setFormToShow} />}
                {formToShow === 'CREATE_ACCOUNT' && (
                  <CreateAccountForm defaultEmail={email} verificationToken={token} onSwitchForm={setFormToShow} />
                )}
                {formToShow === 'FORGOT_PASSWORD' && <ForgotPasswordForm onSwitchForm={setFormToShow} />}
              </Paper>
              <Typography variant="body2" sx={{ mt: 2 }}>
                <MuiLink component={RouterLink} to="/rules">
                  Read the Rules
                </MuiLink>
              </Typography>
            </Container>
          </Background>
        }
      />
    </Routes>
  );
}

export default UnauthApp;
